import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Home, FileSearch, ClipboardCheck } from 'lucide-react';
import LoginButtonComponent from './LoginButtonComponent';
import ProfileButton from './ProfileButtonComponent';

const MainLayout: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth0();

  const isActive = (path: string) => {
    if (path === '/sow') {
      return location.pathname === '/sow' || location.pathname.startsWith('/sow/');
    }
    if (path === '/bids') {
      return location.pathname === '/bids' || location.pathname.startsWith('/bids/');
    }
    if (path === '/inspections') {
      return location.pathname === '/inspections' || location.pathname.startsWith('/inspections/');
    }
    return location.pathname === path;
  };

  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-white border-b border-gray-200 z-50">
      <div className="h-full max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between">
        {/* Left: Logo + Nav links */}
        <div className="flex items-center gap-8">
          <Link to="/sow" className="flex items-center gap-2 flex-shrink-0">
            <img src="/Fxer.AI (7).png" alt="Fxer" className="h-7 w-auto" />
            <span className="font-bold text-lg text-gray-900 hidden sm:block">Fxer</span>
          </Link>

          <nav className="flex items-center gap-1">
            <Link
              to="/sow"
              className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                isActive('/sow')
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              <Home className="h-4 w-4" />
              Renovations
            </Link>
            <Link
              to="/bids"
              className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                isActive('/bids')
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              <FileSearch className="h-4 w-4" />
              Bid Review
            </Link>
            <Link
              to="/inspections"
              className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                isActive('/inspections')
                  ? 'bg-gray-100 text-gray-900'
                  : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
              }`}
            >
              <ClipboardCheck className="h-4 w-4" />
              Inspections
            </Link>
          </nav>
        </div>

        {/* Right: Profile */}
        <div className="flex items-center">
          {!isLoading && (
            !isAuthenticated ? (
              <LoginButtonComponent />
            ) : (
              <ProfileButton />
            )
          )}
        </div>
      </div>
    </header>
  );
};

export default MainLayout;
